// import React, { useEffect } from "react";
// import { Joyride, STATUS, EVENTS, ACTIONS } from "react-joyride";
// import { useOnboarding } from "./OnboardingContext";
// import tourSteps from "./TourSteps";
// import { useLocation, useNavigate } from "react-router-dom";
// import './JoyrideOverrides.css';

// const GlobalTour = () => {
//   const { runTour, setRunTour, stepIndex, setStepIndex } = useOnboarding();
//   const location = useLocation();
//   const navigate = useNavigate();

//   // 1. Sync tour to router logic
//   useEffect(() => {
//     if (!runTour) return;
//     const path = location.pathname;

//     if (path === "/cases" && stepIndex === 0) {
//       const timer = setTimeout(() => setStepIndex(1), 300);
//       return () => clearTimeout(timer);
//     } else if (path === "/cases/new" && stepIndex === 1) {
//       const timer = setTimeout(() => setStepIndex(2), 300);
//       return () => clearTimeout(timer);
//     } else if (path === "/clients/new" && stepIndex === 2) {
//       const timer = setTimeout(() => setStepIndex(3), 300);
//       return () => clearTimeout(timer);
//     } else if (path === "/cases/new" && stepIndex === 3) {
//       const timer = setTimeout(() => setStepIndex(4), 800);
//       return () => clearTimeout(timer);
//     } else if (path === "/cases" && stepIndex === 4) {
//       const timer = setTimeout(() => setStepIndex(5), 500);
//       return () => clearTimeout(timer);
//     } else if (
//       path.startsWith("/cases/") &&
//       !path.includes("/new") &&
//       !path.includes("/edit") &&
//       stepIndex === 5
//     ) {
//       const timer = setTimeout(() => setStepIndex(6), 500);
//       return () => clearTimeout(timer);
//     }
//   }, [location.pathname, runTour, stepIndex, setStepIndex]);

//   // --- PERFECT CENTER SCROLL FAILSAFE ---
//   useEffect(() => {
//     if (runTour && tourSteps[stepIndex]) {
//         const targetSelector = tourSteps[stepIndex].target;
//         const timer = setTimeout(() => {
//             const element = document.querySelector(targetSelector);
//             if (element) {
//                 element.scrollIntoView({ behavior: 'smooth', block: 'center' });
//             }
//         }, 800); 
//         return () => clearTimeout(timer);
//     }
//   }, [stepIndex, runTour]);

//   const handleJoyrideCallback = (data) => {
//     const { action, index, status, type } = data;

//     // HARD PROTECT: Do not let the tour end unless finished
//     if (status === STATUS.FINISHED) {
//       setRunTour(false);
//       setStepIndex(0);
//       return;
//     }
    
//     // If it was skipped or closed by accident, restart it or handle it
//     if (status === STATUS.SKIPPED) {
//        // Only allow skip if the user actually finishes
//        setRunTour(false);
//        setStepIndex(0);
//        return;
//     }

//     if (type === EVENTS.STEP_AFTER || action === ACTIONS.NEXT) {
//       const nextIndex = index + 1;
//       if (index === 0) navigate("/cases");
//       if (index === 1) navigate("/cases/new");
//       if (index === 2) navigate("/clients/new");
//       if (index === 3) navigate("/cases/new");
//       if (index === 4) navigate("/cases");

//       if (index <= 4) {
//         setStepIndex(nextIndex);
//       }
//     }
//   };

//   return (
//     <Joyride
//       callback={handleJoyrideCallback}
//       continuous={true}
//       run={runTour}
//       stepIndex={stepIndex}
//       steps={tourSteps}
//       showSkipButton={false}
//       hideCloseButton={true}
//       hideBackButton={true}
//       disableOverlayClose={true} // DO NOT close on background click
//       disableCloseOnEsc={true}    // DO NOT close on escape key
//       spotlightClicks={true}      // ALLOW clicking your ACTUAL buttons
//       disableScrolling={false} 
//       scrollToFirstStep={true} 
//       disableScrollParentFix={false} 
//       scrollOffset={300} 
//       scrollDuration={500} 
//       floaterProps={{
//         disableAnimation: false, 
//       }}
//       styles={{
//         options: {
//           zIndex: 20000,
//           primaryColor: "#2563eb",
//           backgroundColor: "#ffffff",
//           textColor: "#1f2937",
//           spotlightPadding: 20,
//           overlayColor: 'rgba(0, 0, 0, 0.85)',
//         },
//         tooltipContainer: {
//           textAlign: "left",
//         },
//         // WIPE OUT ALL DEFAULT BUTTONS IN JAVASCRIPT
//         buttonNext: { display: "none" },
//         buttonBack: { display: "none" },
//         buttonClose: { display: "none" },
//         buttonSkip: { display: "none" },
//       }}
//     />
//   );
// };

// export default GlobalTour;



import React, { useEffect } from "react";
import { Joyride, STATUS, EVENTS, ACTIONS } from "react-joyride";
import { useOnboarding } from "./OnboardingContext";
import tourSteps from "./TourSteps";
import { useLocation, useNavigate } from "react-router-dom";
import './JoyrideOverrides.css';

const GlobalTour = () => {
 const { runTour, setRunTour, stepIndex, setStepIndex } = useOnboarding();
 const location = useLocation();
 const navigate = useNavigate();

 // 1. Sync tour to router logic
 useEffect(() => {
  if (!runTour) return;
  const path = location.pathname;

  if (path === "/cases" && stepIndex === 0) {
   const timer = setTimeout(() => setStepIndex(1), 300);
   return () => clearTimeout(timer);
  } else if (path === "/cases/new" && stepIndex === 1) {
   const timer = setTimeout(() => setStepIndex(2), 300);
   return () => clearTimeout(timer);
  } else if (path === "/clients/new" && stepIndex === 2) {
   const timer = setTimeout(() => setStepIndex(3), 300);
   return () => clearTimeout(timer);
  } else if (path === "/cases/new" && stepIndex === 3) {
   const timer = setTimeout(() => setStepIndex(4), 800);
   return () => clearTimeout(timer);
  } else if (path === "/cases" && stepIndex === 4) {
   const timer = setTimeout(() => setStepIndex(5), 500);
   return () => clearTimeout(timer);
  } else if (
   path.startsWith("/cases/") &&
   !path.includes("/new") &&
   !path.includes("/edit") &&
   stepIndex === 5
  ) {
   const timer = setTimeout(() => setStepIndex(6), 500);
   return () => clearTimeout(timer);
  }
 }, [location.pathname, runTour, stepIndex, setStepIndex]);

 // --- PERFECT CENTER SCROLL FAILSAFE ---
 useEffect(() => {
  if (runTour && tourSteps[stepIndex]) {
    const targetSelector = tourSteps[stepIndex].target;
    const timer = setTimeout(() => {
      const element = document.querySelector(targetSelector);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 800); 
    return () => clearTimeout(timer);
  }
 }, [stepIndex, runTour]);

 const handleJoyrideCallback = (data) => {
  const { action, index, status, type } = data;

  // HARD PROTECT: Do not let the tour end unless finished
  if (status === STATUS.FINISHED) {
   setRunTour(false);
   setStepIndex(0);
   return;
  }
  
  // If it was skipped or closed by accident, restart it or handle it
  if (status === STATUS.SKIPPED) {
   // Only allow skip if the user actually finishes
   setRunTour(false);
   setStepIndex(0);
   return;
  }

  if (type === EVENTS.STEP_AFTER || action === ACTIONS.NEXT) {
   const nextIndex = index + 1;
   if (index === 0) navigate("/cases");
   if (index === 1) navigate("/cases/new");
   if (index === 2) navigate("/clients/new");
   if (index === 3) navigate("/cases/new");
   if (index === 4) navigate("/cases");

   if (index <= 4) {
    setStepIndex(nextIndex);
   }
  }
 };

 return (
  <Joyride
   callback={handleJoyrideCallback}
   continuous={true}
   run={runTour}
   stepIndex={stepIndex}
   steps={tourSteps}
   showSkipButton={false}
   hideCloseButton={true}
   hideBackButton={true}
   disableOverlayClose={true} // DO NOT close on background click
   disableCloseOnEsc={true}  // DO NOT close on escape key
   spotlightClicks={true}   // ALLOW clicking your ACTUAL buttons
   disableScrolling={false} 
   scrollToFirstStep={true} 
   disableScrollParentFix={false} 
   scrollOffset={300} 
   scrollDuration={500} 
   floaterProps={{
    disableAnimation: false, 
   }}
   styles={{
    options: {
     zIndex: 20000,
     primaryColor: "#2563eb",
     backgroundColor: "#ffffff",
     textColor: "#1f2937",
     spotlightPadding: 20,
     overlayColor: 'rgba(0, 0, 0, 0.85)',
    },
    tooltipContainer: {
     textAlign: "left",
    },
    // WIPE OUT ALL DEFAULT BUTTONS IN JAVASCRIPT
    buttonNext: { display: "none" },
    buttonBack: { display: "none" },
    buttonClose: { display: "none" },
    buttonSkip: { display: "none" },
   }}
   
   
  />
  
 );
};

export default GlobalTour;